module.exports = "/images/vendor/flag-icon-css/flags/4x3/gb-sct.svg?4c2c379f607fe46e0cec999154ea0ba8";